/**
 * 用户API服务
 * 用于处理用户登录、注册和获取用户信息
 */

import { getApiUrl, API } from './config';
import axios from 'axios';
import { BASE_URL } from './config';

/**
 * 用户登录
 * @param {String} account 账号（用户名或手机号）
 * @param {String} password 密码
 * @returns {Promise} 返回登录结果的Promise
 */
export const login = async (account, password) => {
  try {
    const url = `${getApiUrl(API.USER)}/login`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ account, password })
    });
    
    const data = await response.json();
    
    if (data.code === 1 && data.data) {
      // 登录成功，保存用户信息和token到本地存储
      localStorage.setItem('userInfo', JSON.stringify(data.data.userinfo));
      localStorage.setItem('token', data.data.userinfo.token);
      return data.data.userinfo;
    } else {
      throw new Error(data.msg || '登录失败');
    }
  } catch (error) {
    console.error('登录出错:', error);
    throw error;
  }
};

/**
 * 用户注册
 * @param {String} account 账号（用户名或手机号）
 * @param {String} password 密码
 * @returns {Promise} 返回注册结果的Promise
 */
export const register = async (account, password) => {
  try {
    const url = `${getApiUrl(API.USER)}/register`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ account, password })
    });
    
    const data = await response.json();
    
    if (data.code === 1 && data.data) {
      // 注册成功，保存用户信息和token到本地存储
      localStorage.setItem('userInfo', JSON.stringify(data.data.userinfo));
      localStorage.setItem('token', data.data.userinfo.token);
      return data.data.userinfo;
    } else {
      throw new Error(data.msg || '注册失败');
    }
  } catch (error) {
    console.error('注册出错:', error);
    throw error;
  }
};

/**
 * 获取用户信息
 * @returns {Promise} 返回用户信息的Promise
 */
export const getUserInfo = (token) => {
  return axios.get(`${BASE_URL}/api/user/index`, {
    params: { token }
  })
  .then(response => {
    if (response.data && response.data.code === 1) {
      // 打印用户信息中的金币数据
      console.log('API获取的用户金币数据:', {
        coins: response.data.data.coins,
        type: typeof response.data.data.coins,
        rawData: JSON.stringify(response.data.data)
      });
      return response.data.data;
    }
    throw new Error(response.data.msg || '获取用户信息失败');
  });
};

/**
 * 退出登录
 */
export const logout = () => {
  localStorage.removeItem('userInfo');
  localStorage.removeItem('token');
};

/**
 * 检查是否已登录
 * @returns {Boolean} 是否已登录
 */
export const isLoggedIn = () => {
  const token = localStorage.getItem('token');
  return !!token;
};

/**
 * 获取当前登录的用户信息
 * @returns {Object|null} 用户信息或null
 */
export const getCurrentUser = () => {
  const userInfo = localStorage.getItem('userInfo');
  return userInfo ? JSON.parse(userInfo) : null;
};

// 保存用户信息到本地存储
export const saveUserInfo = (userInfo) => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};

// 保存登录令牌
export const saveToken = (token) => {
  localStorage.setItem('token', token);
};

/**
 * 检查当前用户是否是VIP
 * @returns {Boolean} 是否是VIP用户
 */
export const isVipUser = () => {
  const userInfo = getCurrentUser();
  return userInfo?.is_vip === true;
}; 